if (!customElements.get('skp-audio-player')) {
  customElements.define('skp-audio-player', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.querySelectorAll('[data-track]').forEach((track) => {
        const audio = track.querySelector('audio');
        const button = track.querySelector('[data-play]');
        const range = track.querySelector('[data-range]');
        const duration = track.querySelector('[data-duration]');

        audio.addEventListener('loadedmetadata', () => {
          duration.textContent = this.formatTime(audio.duration);
        });

        audio.addEventListener('timeupdate', () => {
          range.value = audio.duration
            ? (audio.currentTime / audio.duration) * 100
            : 0;
        });

        audio.addEventListener('ended', () => {
          button.textContent = '▶';
        });

        button.addEventListener('click', () => {
          this.querySelectorAll('audio').forEach((otherAudio) => {
            if (otherAudio !== audio) {
              otherAudio.pause();

              otherAudio
                .closest('[data-track]')
                .querySelector('[data-play]').textContent = '▶';
            }
          });

          if (audio.paused) {
            audio.play();
            button.textContent = '❚❚';
          } else {
            audio.pause();
            button.textContent = '▶';
          }
        });

        range.addEventListener('input', () => {
          if (audio.duration) {
            audio.currentTime =
              audio.duration * Number(range.value) / 100;
          }
        });
      });
    }

    formatTime(value) {
      if (!Number.isFinite(value)) return '0:00';

      const minutes = Math.floor(value / 60);
      const seconds = String(Math.floor(value % 60)).padStart(2, '0');

      return `${minutes}:${seconds}`;
    }
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-skp-thumb]');
  if (!button) return;

  const gallery = button.closest('[data-skp-gallery]');
  gallery.querySelector('[data-skp-main]').src = button.dataset.src;

  gallery.querySelectorAll('[data-skp-thumb]').forEach((thumbnail) => {
    thumbnail.classList.remove('is-active');
  });

  button.classList.add('is-active');
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.skp-product-form').forEach((form) => {
    const variantInputs = form.querySelectorAll('[data-skp-variant]');
    const hiddenVariantId = form.querySelector('[data-skp-variant-id]');
    const buyButton = form.querySelector('[data-skp-buy]');
    const projectNotice = form.querySelector('[data-skp-project-notice]');

    const section = form.closest('.skp-section');
    const currentPrice = section?.querySelector('.skp-price__current');
    const comparePrice = section?.querySelector('.skp-price__compare');

    if (!variantInputs.length || !hiddenVariantId) return;

    const selectVariant = (input) => {
      const edition = input.closest('[data-skp-edition]');
      const allEditions = form.querySelectorAll('[data-skp-edition]');

      allEditions.forEach((item) => {
        item.classList.remove('is-selected');
      });

      edition?.classList.add('is-selected');

      hiddenVariantId.value = input.value;

      const isAvailable = input.dataset.available === 'true';
      const isComplete = input.dataset.complete === 'true';

      if (buyButton) {
        buyButton.disabled = !isAvailable;
        buyButton.textContent = isAvailable
          ? 'COMPRAR Y DESCARGAR'
          : 'AGOTADO';
      }

      if (currentPrice && input.dataset.price) {
        currentPrice.textContent = input.dataset.price;
      }

      if (comparePrice) {
        const compareValue = input.dataset.comparePrice || '';

        if (
          compareValue &&
          compareValue !== '$0.00' &&
          compareValue !== '0'
        ) {
          comparePrice.textContent = compareValue;
          comparePrice.style.display = '';
        } else {
          comparePrice.style.display = 'none';
        }
      }

      if (projectNotice) {
        projectNotice.classList.toggle('is-hidden', !isComplete);
      }
    };

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => {
        selectVariant(input);
      });
    });

    const selectedInput = form.querySelector(
      '[data-skp-variant]:checked'
    );

    if (selectedInput) {
      selectVariant(selectedInput);
    }
  });
});